const TOTAL_VARIANTS = {
  regular: 'regular',
  naked: 'naked',
  subtotal: 'subtotal',
};

export default TOTAL_VARIANTS;
